import React from 'react';
import moment from 'moment';
import { Constants } from '../helpers/constants';
import { Box } from '@mui/material';

export const FxDateDisplay = (props: any) => {
    const { value, displayType } = props;

    const computeDate = (date: any, format: any) => {
        let momentDate = moment(new Date(date));
        return momentDate.format(format);
    }

    return (
        <>
            {displayType == "date" &&
                <Box component="span" title={computeDate(value, Constants.DateFormat)}>
                    {computeDate(value, Constants.DateFormat)}
                </Box>
            }
            {displayType == "datetime" &&
                <Box component="span" title={computeDate(value, Constants.DateTimeFormat)}>
                    {computeDate(value, Constants.DateTimeFormat)}
                </Box>
            }
        </>
    )
}